export enum ServerErrorsRoutes {
  GetOne = 'get-one',
  GetSummaries = 'get-summaries',
}
